import { memo } from 'react';

function SignatoriesIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 15.5999H17V14.1999C17 13.0401 16.0598 12.0999 14.9 12.0999C14.2311 12.0999 13.6352 12.4127 13.2506 12.8999M13.5 15.5999H6.5M13.5 15.5999V14.1999C13.5 13.7405 13.4115 13.3018 13.2506 12.8999M6.5 15.5999H3V14.1999C3 13.0401 3.9402 12.0999 5.1 12.0999C5.76892 12.0999 6.3648 12.4127 6.74937 12.8999M6.5 15.5999V14.1999C6.5 13.7405 6.5885 13.3018 6.74937 12.8999M6.74937 12.8999C7.26545 11.6106 8.52637 10.6999 10 10.6999C11.4736 10.6999 12.7345 11.6106 13.2506 12.8999M12.1 6.4999C12.1 7.6597 11.1598 8.5999 10 8.5999C8.8402 8.5999 7.9 7.6597 7.9 6.4999C7.9 5.3401 8.8402 4.3999 10 4.3999C11.1598 4.3999 12.1 5.3401 12.1 6.4999ZM16.3 8.5999C16.3 9.3731 15.6732 9.9999 14.9 9.9999C14.1268 9.9999 13.5 9.3731 13.5 8.5999C13.5 7.8267 14.1268 7.1999 14.9 7.1999C15.6732 7.1999 16.3 7.8267 16.3 8.5999ZM6.5 8.5999C6.5 9.3731 5.8732 9.9999 5.1 9.9999C4.3268 9.9999 3.7 9.3731 3.7 8.5999C3.7 7.8267 4.3268 7.1999 5.1 7.1999C5.8732 7.1999 6.5 7.8267 6.5 8.5999Z"
        stroke="#6B7280"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(SignatoriesIcon);
